<template>
  <div>
    <div
      @click="$store.commit('SET_WORKED_DAYS_MODAL', true)"
      class="u-border u-radius-g u-padding-xxsmall u-hover-select u-margin-right-small u-color-primary"
    >
      <span>
        {{ $t("saleTarget.workedDay") }} : {{ workedDays.workedDay }}</span
      >
      <span>
        {{ $t("saleTarget.workDaysAfterToday") }} :
        {{ workedDays.workDaysAfterToday }}
      </span>
      <i class="icofont-rounded-right"></i>
    </div>
    <Modal
      persistent
      @ok="saveWorkedDay"
      :value="workedDays.workedDaysModal"
      @input="$store.commit('SET_WORKED_DAYS_MODAL', $event)"
      :title="$t('saleTarget.workedDaysModal')"
    >
      <div class="u-margin-bottom-small">
        {{ $t("saleTarget.workedDaysModalDescription") }}
      </div>
      <BaseInput
        :value="workedDays.workedDay"
        block
        type="number"
        @input="setWorkedDay($event, 'workedDay')"
        :label="$t('saleTarget.workedDay')"
        :placeholder="$t('saleTarget.workedDay')"
      />
      <BaseInput
        :value="workedDays.workDaysAfterToday"
        block
        type="number"
        @input="setWorkedDay($event, 'workDaysAfterToday')"
        :label="$t('saleTarget.workDaysAfterToday')"
        :placeholder="$t('saleTarget.workDaysAfterToday')"
      />
      <div class="o-alert o-alert--warning">
        {{ $t("saleTarget.workedDaysModalWarning") }}
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/Base/Modal.vue";
import BaseInput from "../Base/Inputs/BaseInput.vue";
export default {
  components: { Modal, BaseInput },
  computed: {
    workedDays() {
      return this.$store.getters.getWorkedDays;
    },
  },
  methods: {
    setWorkedDay(value, type) {
      this[type] = value;
      localStorage.setItem(
        "workedDays",
        JSON.stringify({
          workedDay: this.workedDay,
          workDaysAfterToday: this.workDaysAfterToday,
          storageCreatedDate: new Date().toISOString(),
        })
      );
      this.$store.commit("SET_WORKED_DAYS", {
        ...this.$store.getters.getWorkedDays,
        workedDay: this.workedDay,
        workDaysAfterToday: this.workDaysAfterToday,
        storageCreatedDate: new Date().toISOString(),
      });
      this.$emit("change");
    },
    saveWorkedDay() {
      this.$store.commit("SET_WORKED_DAYS_MODAL", false);
      this.saveWorkedDay(this.workedDay, "workedDay");
      this.saveWorkedDay(this.workDaysAfterToday, "workDaysAfterToday");
      this.$emit("change");
    },
    getWorkedDay() {
      try {
        const workedDaysString = localStorage.getItem("workedDays");
        if (!workedDaysString) return;
        const workedDays = JSON.parse(workedDaysString);
        this.workedDay = workedDays.workedDay;
        this.workDaysAfterToday = workedDays.workDaysAfterToday;
        const today = new Date().getDate();
        const storageCreatedDate = workedDays.storageCreatedDate;
        const storageCreatedDateObj = new Date(storageCreatedDate);
        const storageCreatedDateDay = storageCreatedDateObj?.getDate();
        const diffDays = today - storageCreatedDateDay;
        this.workedDaysModal = diffDays > 0;
        this.$store.commit("SET_WORKED_DAYS", {
          workedDay: this.workedDay,
          workDaysAfterToday: this.workDaysAfterToday,
          storageCreatedDate: storageCreatedDateObj || new Date().toISOString(),
          diffDays: diffDays,
          today: today,
          workedDaysModal: diffDays > 0,
        });
      } catch (error) {
        this.$store.commit("SET_WORKED_DAYS", {
          workedDay: 1,
          workDaysAfterToday: 19,
          storageCreatedDate: new Date().toISOString(),
          diffDays: 0,
          today: new Date().getDate(),
          workedDaysModal: true,
        });
      }
    },
  },
  mounted() {
    this.getWorkedDay();
  },
};
</script>

<style></style>
